import { render, staticRenderFns, recyclableRender, components } from "./report_details.vue?vue&type=template&id=d357e834&scoped=true&"
var renderjs
import script from "./report_details.vue?vue&type=script&lang=js&"
export * from "./report_details.vue?vue&type=script&lang=js&"
import style0 from "./report_details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./report_details.vue?vue&type=style&index=1&id=d357e834&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d357e834",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/report_details/report_details.vue"
export default component.exports